module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("elPpZ"))).then(() => parcelRequire('cvs7o'));